/**
 * Добавляет макротаску на открытие страницы в этом же окне,
 * для предотвращения прерывания отправки событий
 * @param url
 */
export const navigateToPage = (url: string) => setTimeout(() => window.location.assign(url));
